import React from 'react';
import { Button, LabeledInput, LabeledCheckbox, AlertNotification } from "@commonsku/styles";
import {oauth} from '../../utils';

const defaultDateCreatedFrom = `${new Date().getFullYear()}-01-01`;

const BackfillQboInvoiceExports = () => {
  const [response, setResponse] = React.useState('');
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState('');
  const [dryRun, setDryRun] = React.useState(true);

  return <form action="" onSubmit={async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setResponse('');

    const formData = Object.fromEntries(new FormData(e.currentTarget).entries());
    const tenantDomainKey = String(formData.tenant_domain_key ?? '');
    const dateCreatedFrom = String(formData.date_created_from ?? '');

    if (!dryRun) {
      const confirmed = window.confirm(
        `Apply QBO invoice export backfill for tenant "${tenantDomainKey}" ` +
        `(created on or after ${dateCreatedFrom})?\n\n` +
        'Matched invoices will be marked exported in commonsku with their QBO TxnId.'
      );
      if (!confirmed) {
        return;
      }
    }

    try {
      const apiResponse = await oauth('POST', 'tech-support', {
        tenant_domain_key: tenantDomainKey,
        date_created_from: dateCreatedFrom,
        dry_run: dryRun,
        actionName: 'backfill_qbo_invoice_exports',
      });

      const data = apiResponse.json;
      setResponse(JSON.stringify(data, null, 2));

      const { summary } = data;
      const truncatedNote = summary.truncated
        ? ` Truncated to ${summary.candidates} candidates — re-run to process the rest.`
        : '';
      if (data.dry_run) {
        setSuccess(
          `Dry run complete: ${summary.candidates} candidates, ` +
          `${summary.matched} matched, ${summary.not_found} not found, ` +
          `${summary.errors} errors.${truncatedNote}`
        );
      } else {
        setSuccess(
          `Apply complete: ${summary.applied} invoices updated ` +
          `(${summary.matched} matched, ${summary.not_found} not found, ` +
          `${summary.errors} errors).${truncatedNote}`
        );
      }
    } catch (err) {
      const apiErrors = err.json?.errors;
      if (Array.isArray(apiErrors) && apiErrors.length > 0) {
        setError(apiErrors.filter((msg) => typeof msg === 'string').join(' '));
      } else if (typeof err.json?.error === 'string') {
        setError(err.json.error);
      } else if (typeof err.json?.message === 'string' && err.json.message !== 'Bad Request') {
        setError(err.json.message);
      } else if (err.response?.status === 404) {
        setError('Tenant not found. Please check the tenant domain key and try again.');
      } else if (err.response?.status === 403) {
        setError('Access denied. You do not have permission to perform this action.');
      } else {
        setError('An error occurred while processing your request. Please try again.');
      }
    }
  }}>
    <LabeledInput
      label="Tenant Domain Key"
      placeholder="Enter tenant domain key"
      name="tenant_domain_key"
      type="text"
      required
    />
    <LabeledInput
      label="Created on or after"
      name="date_created_from"
      type="date"
      defaultValue={defaultDateCreatedFrom}
      required
    />
    <LabeledCheckbox
      label="Dry run (report only, no database changes)"
      checked={dryRun}
      onClick={() => setDryRun(!dryRun)}
    />
    <Button type="submit">
      {dryRun ? 'Run Dry Run' : 'Apply Backfill'}
    </Button>

    {error && (
      <AlertNotification alertType="error" style={{marginTop: '10px'}}>
        {error}
      </AlertNotification>
    )}

    {success && (
      <AlertNotification alertType="success" style={{marginTop: '10px'}}>
        {success}
      </AlertNotification>
    )}

    {response && <pre>{response}</pre>}
  </form>;
};

BackfillQboInvoiceExports.label = 'Backfill QBO Invoice Exports';

export default BackfillQboInvoiceExports;
